import { AxiosError } from 'axios';

export const checkIsServerError = (error: Error | null) => {
  if (
    error instanceof AxiosError &&
    error?.response?.status &&
    error.response.status >= 500
  ) {
    return true;
  }

  if (error instanceof Response && error?.status && error.status >= 400) {
    return true;
  }

  return false;
};
